import type { DesktopMode } from "@/stores/desktop-mode-store";

type DesktopLayoutVisibilityInput = {
  isDesktopTauri: boolean;
  desktopMode: DesktopMode;
  compactFrameOverlayActive?: boolean;
  denkWorkspacePreview: boolean;
  denkCanvasCapture?: boolean;
};

export function getDesktopLayoutVisibility({
  isDesktopTauri,
  desktopMode,
  compactFrameOverlayActive = false,
}: DesktopLayoutVisibilityInput) {
  const desktopCompactMode =
    isDesktopTauri && (desktopMode === "compact" || compactFrameOverlayActive);
  const desktopChromeSuppressed = false;
  const desktopWorkspaceSurface = desktopMode === "denk";
  const showDesktopCanvasContent =
    !desktopCompactMode || compactFrameOverlayActive;
  const showLeftHeaderIsland = false;
  const showRightHeaderIsland = false;
  const showCenterHeaderChrome = !isDesktopTauri && !desktopChromeSuppressed;
  const showAppHeaderChrome =
    showCenterHeaderChrome || showLeftHeaderIsland || showRightHeaderIsland;
  const showCanvasLeftRail =
    !desktopCompactMode && (!isDesktopTauri || desktopWorkspaceSurface);

  return {
    desktopChromeSuppressed,
    desktopCompactMode,
    desktopWorkspaceSurface,
    showAppHeaderChrome,
    showCanvasLeftRail,
    showCenterHeaderChrome,
    showDesktopCanvasContent,
    showLeftHeaderIsland,
    showRightHeaderIsland,
  };
}
